import ApiClient from '../ApiClient';

class InboxChannel extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }
}

export default new InboxChannel();
